export default "__VITE_ASSET__5b61b0d3__"